(function (angular) {
    'use strict';

    angular.module('app.support').config(['$stateProvider', '$urlRouterProvider', supportRoutes]);

    function supportRoutes($stateProvider, $urlRouterProvider) {
        $stateProvider
            .state('app.support', {
                url: '/support',
                templateUrl: '/app/site/support/support.template.html',
                controller: 'app.support.supportController',
                controllerAs: 'vm'
            })
            .state('app.supportplus', {
                url: '/supportplus',
                templateUrl: '/app/site/support/support.template.html',
                controller: 'app.support.supportController',
                controllerAs: 'vm'
            });
    }
})(angular);
